import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  logo: {
    margin: theme.spacing(1),
  },
}));
